// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3540 ? "npm.embla-carousel" : chunkId) + "." + {"3540":"04dd7539f83067eb","4356":"a4cc19034c6dd989","5499":"9bea9c6ceb7864cd","9114":"344a1926cc278dea"}[chunkId] + ".js";
};